<otg-location-picker-list
  [locations]="locations"
  [currentLocationId]="currentLocationId"
  (locationSelected)="selectLocation($event)"
  (addLocationClicked)="addLocation()"
/>
